/*!
 * v-uppercase
 */

const index = {
  /*
  * install function
  * @param  {Vue} Vue
  */
  install(Vue) {
    Vue.directive('focus', {
      inserted(el) {
        el.focus();
      },
    });
  },
};

export default index;
